/**
 * "Already managed" markers for candidate cards.
 *
 * When an action succeeds optimistically (archive, move, interview confirmed),
 * the card is NOT removed — it stays on the board, muted, with a "✓ Archived"
 * style chip. That way the recruiter sees at a glance what they already
 * handled this session without a full Lever refresh. The map is cleared on
 * every fresh board pull (handled candidates are gone from fresh data anyway)
 * and persisted in the per-recruiter board cache in between.
 */
import { useCallback, useState } from 'react';

export type HandledMap = Record<string, string>;

export function useHandledCards() {
  const [handled, setHandled] = useState<HandledMap>({});

  const markHandled = useCallback((opportunityId: string, label: string) => {
    setHandled((prev) => ({ ...prev, [opportunityId]: label }));
  }, []);

  const unmarkHandled = useCallback((opportunityId: string) => {
    setHandled((prev) => {
      const next = { ...prev };
      delete next[opportunityId];
      return next;
    });
  }, []);

  return { handled, setHandled, markHandled, unmarkHandled };
}
